//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'LRINEC',
  data() {
    return {
      defaultJson:{
        "Sodium": "血清 Na",
        "Consider Necrotizing Fasciitis": "坏死性筋膜炎考虑",
        "Hemoglobin": "血红蛋白",
        "Creatinine": "肌酐",
        "White cell count": "白细胞计数",
        "C-Reactive protein": "C-反应蛋白",
        "Glucose": "糖"
      },
      form:{
        crp:'',
        wbc:'',
        hb:'',
        na:'',
        crea:'',
        glu:'',
      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // ((crp < 150) ? 0 : 4)	+ ((wbc < 15) ? 0 : ((wbc > 25) ? 2 : 1))	+ ((hb > 13.5) ? 0 : ((hb < 11) ? 2 : 1))	+ ((na < 135) ? 2 : 0)	+ ((crea > 141) ? 2 : 0)	+ ((glu > 10) ? 1 : 0)
        let result = ((form.crp < 150) ? 0 : 4)	+ ((form.wbc < 15) ? 0 : ((form.wbc > 25) ? 2 : 1))	+ ((form.hb > 13.5) ? 0 : ((form.hb < 11) ? 2 : 1))	+ ((form.na < 135) ? 2 : 0)	+ ((form.crea > 141) ? 2 : 0)	+ ((form.glu > 10) ? 1 : 0)
        
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/LRINEC.vue